module.exports = __webpack_public_path__ + "build/img/technical-support.e00cae7c.png";